import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import { toast } from "react-toastify";
// import { apiClient } from "../../utils/api/apiClient";
import Input from "../../components/Common/Input";
import Button from "../../components/Common/Button";
import { ApiService } from "../../components/Common/ApiService";
import ModalBox from "../../components/Common/ModalBox";

function CheckMLPage() {
  const isWebSetting = localStorage.getItem("isWebSetting");
  const parseWebSetting = JSON.parse(isWebSetting);
  const [productData, setProductData] = useState([]);
  const [userID, setUserID] = useState("");
  const [serverID, setServerID] = useState("");
  const [data, setData] = useState({});
  const [loading, isLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
  }, [dispatch]);

  const checkID = async (id) => {
    isLoading(true);
    try {
      const params = new URLSearchParams();
      params.append("id", id);

      const response = await ApiService({
        baseurl: "user/cekRegion",
        method: "POST",
        XGORDON: "CEKREGION",
        body: params,
      });

      if (response?.statusCode === 200) {
        console.log(response);
        isLoading(false);
        if (response?.result?.message === 'ID atau Server tidak valid.') {
          toast.error(response?.result?.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setProductData({});
          setIsModalOpen(false);

        }
        else if (response?.result?.username === 'Tidak ditemukan') {
          toast.error(response?.result.username, {
            position: toast.POSITION.TOP_RIGHT,
          });
          setProductData({});
          setIsModalOpen(false);
        } else {
          setProductData(response?.result);
          setData({ userID: userID, serverID: serverID });
          setIsModalOpen(true);
        }

      } else {

      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="flex flex-col gap-3 p-3 w-full">
      <div className="flex flex-row lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">
        <div className="flex flex-col gap-2 justify-center flex-1 p-3">
          <h1 className="text-3xl  text-[#22BDE2] font-bold">Check Region Mobile Legends</h1>
          <span className=" text-base font-light ">
            Digunakan Untuk Mengecek Informasi Akun Mobile Legends Berdasarkan ID
          </span>
        </div>
        <div className="md:flex hidden flex-1">
          <img
            src={require('../../assets/images/pngwing 1.png')}
            alt="Logo"
            className="object-cover  object-right flex-1 h-40 " />
        </div>
      </div>
      <div className="flex flex-col gap-3 items-center justify-center min-h-[400px] ">
        <div className="flex flex-col gap-2 p-3 rounded-lg bg-cardLight dark:bg-cardDark w-full max-w-lg">
          <h1 className="text-2xl font-bold">
            Check Region Mobile Legends
          </h1>
          <div className="flex flex-col gap-3 w-full">
            <Input
              label={'User ID'}
              id="userID"
              value={userID}
              type="text"
              disabled={loading}
              placeholder={'Masukan User ID'}
              onChange={(event) => setUserID(event)}
            />
            <Input
              label={"Server ID"}
              id="serverID"
              value={serverID}
              disabled={loading}

              type="text"
              placeholder={"Masukan Server ID"}
              onChange={(event) => setServerID(event)}
            />
            <Button
              initialValue={loading ? "Loading..." : "Cek ID"}
              type="fill"
              className="bg-[#22BDE2] text-darkColor"
              onClick={() => {
                checkID(`${userID}|${serverID}`);
              }}
            />
          </div>
        </div>
        <ModalBox active={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <div className="flex flex-col text-white">
            <span className="text-center text-2xl font-bold">
              Informasi Akun Ditemukan!
            </span>
            <span className=" text-sm ">
              User ID
            </span>
            <span className=" text-xl font-bold">
              {data.userID}
            </span>
            <span className=" text-sm ">
              Zone ID
            </span>
            <span className=" text-xl font-bold">
              {data.serverID}
            </span>
            <span className=" text-sm ">
              Username
            </span>
            <span className=" text-xl font-bold">
              {productData?.username}
            </span>
            <span className=" text-sm ">
              Region
            </span>
            <span className=" text-xl font-bold">
              {productData?.region}
            </span>
          </div>
        </ModalBox>
      </div>
    </div>
  );
}

export default CheckMLPage;
